import axios from 'axios'
import router from '@/router'
import storageKeys from '@/tools/storage-keys'
import forbiddenResultCodes from './data/forbidden-result-codes'

axios.interceptors.request.use(
  (config: any) => {
    const tid = localStorage.getItem(storageKeys.TID)
    if (tid !== null) config.headers.tid = tid
    return config
  },
  (error: any) => {
    return error
  })

axios.interceptors.response.use(
  (response: any) => {
    const data = response.data
    const {resultInfo, result} = data
    const {resultCode, msg} = resultInfo
    if (resultCode === 200) return result
    else {
      if (forbiddenResultCodes.includes(resultCode)) {
        localStorage.clear()
        router.replace({path: '/login'})
      }
      throw new Error(msg)
    }
  },
  (error: any) => {
    if (error.response.status === 500) return new Error('服务器连接异常')
    else return error
  })

export default axios
